import { LimitedAccessBanner } from '@components/LimitedAccessBanner';
import { MobileProjectTopBar } from '@components/Layout/MobileProjectTopBar';
import { Box, Stack } from '@mui/material';
import { useGetMe } from '@utils/useGetMe';
import { useResponsive } from '@utils/useResponsive';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { isProjectNavigationMenuCollapsedState } from '../atoms';
import { projectCollapsedMenuWidth, projectExpandedMenuWidth } from '../components/ProjectNavigation';
import { ProjectNavigationMenu } from '../components/ProjectNavigation/ProjectNavigationMenu';
import { ProjectNavigationMenuSpacer } from '../components/ProjectNavigation/ProjectNavigationMenuSpacer';
import { useCurrentProject } from '../utils/useCurrentProject';
import { useGetLoginInfoQuery } from 'gql/index';

export const ProjectLayout: React.FC = () => {

  const { isMobile } = useResponsive();
  const isNavigationMenuCollapsed = useAtomValue(isProjectNavigationMenuCollapsedState);

  const { isFetching: isFetchingMe } = useGetMe();
  const { data: loginInfo } = useGetLoginInfoQuery(undefined, { select: d => d.loginInfo });
  const isSignedInWithMagicLink = loginInfo?.isAuthenticatedWithMagicLink;
  const { query: { isFetching: isFetchingProject } } = useCurrentProject();

  const isLoading = isFetchingMe || isFetchingProject;

  return <>
    {isMobile && (
      <MobileProjectTopBar loading={isLoading} />
    )}

    {isMobile && isSignedInWithMagicLink && (
      <Box sx={{ px: 2, py: 1 }}>
        <LimitedAccessBanner />
      </Box>
    )}

    <ProjectNavigationMenu />
    <Stack component="main" direction="row" height='100%' overflow='auto'>
      <ProjectNavigationMenuSpacer />
      <Box sx={{ width: isNavigationMenuCollapsed ? `${projectCollapsedMenuWidth}px` : `${projectExpandedMenuWidth}px`, flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Stack>
  </>;
};
